import * as React from 'react'
import { AppContext } from './AppContext';
import { User } from './model/User';
import { ApiClient } from './services/api/ApiClient';

export interface AppServiceProps {
    baseUrl: string
    initialUser: User
    renderChildren: (timeTracker: AppContext) => JSX.Element
}

export interface AppServiceState {
}

export class AppService extends React.Component<AppServiceProps, AppServiceState> {
    constructor(props: AppServiceProps) {
        super(props)

        this._apiClient = new ApiClient(props.baseUrl)

        this.state = {
        }
    }

    render = () => {
        const appContext = {
            apiClient: this._apiClient,
            user: this.props.initialUser
        } as AppContext

        return this.props.renderChildren(appContext);
    }

    componentDidMount = () => {
    }


    // ====================== Private ======================
    private _apiClient: ApiClient
}
